import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Path } from './base/Icon';
import type { BaseIconProps } from './types';

// The X (formerly Twitter) mark. Drawn here rather than taken from lucide-react,
// which dropped brand logos and whose `Twitter` is still the retired bird. The
// path is the Simple Icons one (CC0), on a 24 x 24 grid like the other brand
// marks in this folder.
type XLogoProps = BaseIconProps;
const XLogo: React.FC<XLogoProps> = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    width,
    height,
    color
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const iconWidth = width || size;
  const iconHeight = height || size;
  let t2;
  if ($[0] !== color) {
    t2 = <Path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" fill={color} />;
    $[0] = color;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== iconHeight || $[3] !== iconWidth || $[4] !== t2) {
    t3 = <Icon width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none">{t2}</Icon>;
    $[2] = iconHeight;
    $[3] = iconWidth;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default XLogo;